import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "swiper-left",
  "use": "swiper-left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"swiper-left\"><path d=\"M747.3 25.893a36.571 36.571 0 0 0-51.711 0L230.18 491.3a36.571 36.571 0 0 0 0 51.785l465.408 465.48a36.571 36.571 0 1 0 51.712-51.711L307.712 517.266 747.301 77.605a36.571 36.571 0 0 0 0-51.712z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol